import { tryCatch } from '@/services/api-client';
import { dataProvider } from '@/services/data-provider';
import { GetListParams } from '../common/common.types';
import {
  CreateMessageAttachmentBody,
  CreateMessageBody,
  Message,
  MessageAttachment,
  ThreadResponse,
} from './messages.types';

export const getMessagesByConversationId = async ({
  conversationId,
  page,
  perPage,
  sort,
  order,
}: GetListParams & { conversationId: string }) => {
  const { data, error } = await tryCatch(
    dataProvider.getList<ThreadResponse>(
      `messages/enriched/${conversationId}`,
      {
        pagination: { page: page || 1, perPage: perPage || 10 },
        sort: { field: sort || 'updated_at', order: order || 'DESC' },
        filter: { conversation_id: conversationId },
      },
    ),
  );

  if (error) {
    throw error;
  }

  // Return the full response with data and total
  return data || { data: [], total: 0 };
};
export const getMessagesList = async ({
  filter,
  sort,
  order,
  perPage,
  page,
}: GetListParams) => {
  const { data: response, error } = await tryCatch(
    dataProvider.getList<Message>('messages', {
      pagination: { page: page || 1, perPage: perPage || 10 },
      sort: { field: sort || 'updated_at', order: order || 'DESC' },
      filter,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const createMessage = async (data: CreateMessageBody) => {
  const { data: response, error } = await tryCatch(
    dataProvider.create<Message>('messages', {
      data,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const updateMessage = async ({
  id,
  data,
  previousData,
}: {
  id: string;
  data: Message;
  previousData: Message;
}) => {
  const { data: response, error } = await tryCatch(
    dataProvider.update<Message>(`messages`, {
      id,
      data,
      previousData,
    }),
  );
  console.log('MessageFeedback updateMessage response', response);
  if (error) {
    console.log('MessageFeedback error', error);
    throw error;
  }

  return response;
};

export const createMessageAttachment = async (
  data: CreateMessageAttachmentBody,
) => {
  const { data: response, error } = await tryCatch(
    dataProvider.create<MessageAttachment>('message-attachments', {
      data,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const getMessageAttachmentsList = async (data: GetListParams) => {
  const { data: response, error } = await tryCatch(
    dataProvider.getList<MessageAttachment>('message-attachments', {
      pagination: { page: data.page || 1, perPage: data.perPage || 10 },
      sort: { field: data.sort || 'updated_at', order: data.order || 'DESC' },
      filter: data.filter,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};
